import { Box, Button, Flex, FormControl, FormHelperText, FormLabel, Spacer, Stack } from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../stores/pipeline-store';
import { useCallback } from 'react';
import { DrawerCheckbox, DrawerInput, DrawerSelect, VarSelect } from './inputs';

type StepDrawerAnalyticsAccordionItemProps = {
    stepId: string;
};
export function StepDrawerAnalyticsAccordionItem({ stepId }: StepDrawerAnalyticsAccordionItemProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as PipelineStep;

    const setAnalyticsProp = useCallback(
        (propName: string, propValue: unknown) => {
            const analyticsSettings = JSON.parse(
                JSON.stringify(step.analyticsSettings),
            ) as typeof step.analyticsSettings;
            (analyticsSettings as Record<string, unknown>)[propName] = propValue;
            updateStep(stepId, 'analyticsSettings', analyticsSettings);
        },
        [stepId, step.analyticsSettings, updateStep],
    );

    return (
        <Box mx={-3}>
            <FormControl>
                <DrawerCheckbox
                    isChecked={step.analyticsSettings.sendEvent}
                    onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
                        setAnalyticsProp('sendEvent', checked);
                    }}
                >
                    Send event to Analytics Server
                </DrawerCheckbox>
            </FormControl>

            {step.analyticsSettings.sendEvent && (
                <>
                    <FormControl mt={2}>
                        <FormLabel>Event Name</FormLabel>
                        <DrawerInput
                            placeholder="Event name"
                            value={step.analyticsSettings.eventName}
                            onChange={(e) => setAnalyticsProp('eventName', e.target.value)}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Distinct Id</FormLabel>
                        <FormHelperText mb={2}>Defaults to facilitator id</FormHelperText>
                        <VarSelect
                            value={step.analyticsSettings.distinctId}
                            onChange={(value) => setAnalyticsProp('distinctId', value)}
                            filterByType={['STRING', 'NUMBER', 'BOOLEAN']}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Payload</FormLabel>
                        <Stack>
                            {step.analyticsSettings.payload.map((paramElem, index) => {
                                return (
                                    <Flex key={index}>
                                        <Button
                                            backgroundColor="white"
                                            _hover={{ color: '#f0706e' }}
                                            _focus={{
                                                backgroundColor: 'white',
                                            }}
                                            _active={{
                                                backgroundColor: 'white',
                                            }}
                                            color={'grey'}
                                            leftIcon={<DeleteIcon />}
                                            onClick={() => {
                                                let payload = JSON.parse(
                                                    JSON.stringify(step.analyticsSettings.payload),
                                                );
                                                payload.splice(index, 1);
                                                setAnalyticsProp('payload', payload);
                                            }}
                                        ></Button>
                                        <DrawerInput
                                            placeholder="key"
                                            value={paramElem.key}
                                            width="300px"
                                            onChange={(e) => {
                                                const payload = JSON.parse(
                                                    JSON.stringify(step.analyticsSettings.payload),
                                                );
                                                payload[index].key = e.target.value;
                                                setAnalyticsProp('payload', payload);
                                            }}
                                        />
                                        <Spacer minW={1} />
                                        <DrawerSelect
                                            value={paramElem.propOrigin}
                                            width="200px"
                                            onChange={(e) => {
                                                const payload = JSON.parse(
                                                    JSON.stringify(step.analyticsSettings.payload),
                                                );
                                                payload[index].propOrigin = e.target.value;
                                                setAnalyticsProp('payload', payload);
                                            }}
                                        >
                                            <option value="" disabled={true}>
                                                origin
                                            </option>
                                            <option value="var">Var</option>
                                            <option value="cycle_settings">Cycle Settings</option>
                                            <option value="cycle_state">Cycle state</option>
                                            <option value="settings">Settings</option>
                                        </DrawerSelect>
                                        <Box width={'300px'}>
                                            {paramElem.propOrigin === 'var' ? (
                                                <VarSelect
                                                    value={paramElem.valueVarId ?? ''}
                                                    placeholder="Var"
                                                    onChange={(value) => {
                                                        const payload = JSON.parse(
                                                            JSON.stringify(step.analyticsSettings.payload),
                                                        );
                                                        payload[index].valueVarId = value;
                                                        setAnalyticsProp('payload', payload);
                                                    }}
                                                />
                                            ) : (
                                                <DrawerInput
                                                    placeholder="Value"
                                                    value={paramElem.value ?? ''}
                                                    onChange={(e) => {
                                                        const payload = JSON.parse(
                                                            JSON.stringify(step.analyticsSettings.payload),
                                                        );
                                                        payload[index].value = e.target.value;
                                                        setAnalyticsProp('payload', payload);
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Flex>
                                );
                            })}

                            <Button
                                backgroundColor="white"
                                _hover={{
                                    backgroundColor: 'white',
                                    color: 'black',
                                }}
                                _focus={{ backgroundColor: 'white' }}
                                _active={{ backgroundColor: 'white' }}
                                color={'grey'}
                                leftIcon={<AddIcon />}
                                onClick={() => {
                                    let payload = JSON.parse(JSON.stringify(step.analyticsSettings.payload));
                                    payload.push({
                                        key: '',
                                        valueIsVar: true,
                                        value: '',
                                        valueVarId: '',
                                        propOrigin: 'var',
                                    });
                                    setAnalyticsProp('payload', payload);
                                }}
                            >
                                Add param
                            </Button>
                        </Stack>
                    </FormControl>
                </>
            )}
        </Box>
    );
}
